export enum KnmListTypesWithParamsEnum {
  TOTAL = 'totalKnm',
  UNDER_CONSIDERATION = 'underConsiderationKnm',
  AGREED = 'agreedKnm',
  EXCLUDED = 'excludedKnm',
  APPEALED = 'appealedKnm',
  COMMENTS_EXIST = 'commentsExistKnm',
  FILL_IN_PROCESS = 'fillInProcessKnm',
  READY_FOR_APPROVE = 'readyForApproveKnm',
}
